import { Type } from '@angular/core';
import { InjectionToken } from '@angular/core';
import { DfsGlobalsService } from './core/dfs-globals.service';

export namespace NDfs {
    /**
     * Options injection token
     */
    export const OPTIONS = new InjectionToken<IOptions>('DFS_OPTIONS');

    /**
     * General interface for rules
     * className switches to class mode
     */
    export type TRule = IParserRule | IComboRule | string | 'className';

    /**
     * Basic property rule definition
     */
    export interface IParserRule {
        prop: string;
        parser?: Type<IParser>;
        parserOptions?: any;
    }
    /**
     * Combo definition
     */
    export interface IComboRule {
        combo: (string | (() => ICssEntry))[];
    }

    export interface ICssEntry {
        prop: string;
        value: string;
        size?: ('S' | 'M' | 'L' | 'X')[];
    }

    export interface IClassesEntry {
        className: string;
        size?: ('S' | 'M' | 'L' | 'X')[];
    }

    /**
     * Style parser
     */
    export interface IParser {
        /**
         * Parses value of a DFS definition into css rules
         */
        parse(dfsGlobalsService: DfsGlobalsService, value: string, options?: any): NDfs.ICssEntry[];
    }

    /**
     * Configuration options
     */
    export interface IOptions {
        // styles unique scope id
        scope: string;

        // space quant - distances are multiplication of this value
        distanceQuant: TPerSize<string> | string;

        // colors
        color: IOptionEntry;

        // text styles
        text?: IOption[];

        // general layout
        layout: {
            wrap?: {
                // default is required
                default: {
                    width: TPerSize<string> | string;
                    padding: TPerSize<string> | string;
                };
                // custom ones are optional
                [id: string]: {
                    width: TPerSize<string> | string;
                    padding: TPerSize<string> | string;
                };
            };
            gridSize: number;
            gridGutter: TPerSize<string> | string;
        };

        // all the rest
        custom: {
            [configId: string]: IOptionEntry;
        };
    }

    /**
     * Configuration entry
     */
    export interface IOptionEntry {
        [id: string]: IOption;
    }

    export interface IOption {
        value: string;
        title: string;
        group?: string;
    }

    export type TPerSize<T> = [T, T, T, T];

    /**
     * Dimension value that includes value and unit
     */
    export interface IDimension {
        value: number;
        unit: string;
    }
}
